import abcLogo from "@/assets/media-logos/abc.svg";
import cbsLogo from "@/assets/media-logos/cbs.svg";
import cnnLogo from "@/assets/media-logos/cnn.svg";
import nbcLogo from "@/assets/media-logos/nbc.svg";
import type { CSSProperties } from "react";

export function MediaLogos() {
  const logoStyle: CSSProperties = {
    width: "20%",
    aspectRatio: "3/2",
    objectFit: "contain",
  };

  return (
    <div
      style={{
        paddingTop: "5%",
        paddingRight: "10%",
        paddingLeft: "10%",
        display: "flex",
        justifyContent: "space-around",
      }}
    >
      <img style={logoStyle} src={cbsLogo} alt="cbs" />
      <img style={logoStyle} src={nbcLogo} alt="nbc" />
      <img style={logoStyle} src={abcLogo} alt="abc" />
      <img style={logoStyle} src={cnnLogo} alt="cnn" />
    </div>
  );
}
